import React from "react";
import { graphql } from "gatsby";
import ObjectLayout from "./../components/ObjectLayout";
import { ObjectBody } from "./../components/ObjectLayout/elements";
import ObjectHeader from "./../components/ObjectHeader";
import ObjectConnections from "./../components/ObjectConnections";
import ImageBlock from "./../components/ImageBlock";

const ImagePage = ({ data, pageContext }) => {
  const {
    title,
    description,
    date,
    dateApproximateness,
    endDate,
    endDateApproximateness,
    people,
    imageFile,
    keywords,
    mediaType,
    _rawNotes,
  } = data.sanityObjectImage;
  // console.log(data, pageContext.id);
  return (
    <ObjectLayout title={`Image: ${title}`}>
      <ObjectHeader
        title={title}
        subtitle={(mediaType && mediaType.title) || ""}
        date={date}
        endDate={endDate}
        dateApproximateness={dateApproximateness}
        endDateApproximateness={endDateApproximateness}
      />
      <ObjectBody>
        <ImageBlock
          description={description}
          notes={_rawNotes}
          image={imageFile.asset.gatsbyImageData}
          title={title}
        />
      </ObjectBody>
      {people.length || keywords.length ? (
        <ObjectConnections people={people} keywords={keywords} />
      ) : null}
    </ObjectLayout>
  );
};

export default ImagePage;

export const pageQuery = graphql`
  query($id: String!) {
    sanityObjectImage(_id: { eq: $id }) {
      title
      description
      date
      dateApproximateness
      endDate
      endDateApproximateness
      _rawNotes(resolveReferences: { maxDepth: 10 })
      imageFile {
        asset {
          gatsbyImageData(width: 800)
        }
      }
      mediaType {
        title
      }
      people {
        _id
        title
      }
      keywords {
        _id
        title
      }
    }
  }
`;
